export default __webpack_public_path__ + "static/media/GreenBackgroundHeader.ec37df6f.png";